import { useEffect, useCallback } from "react";
import socket from "./Config";

export const useSocket = (event, callback) => {

  useEffect(() => {
    if (!event || !callback) return;

    const handler = (data) => {
      console.log("📩 Received:", event, data);
      callback(data);
    };

    socket.on(event, handler);

    return () => {
      socket.off(event, handler);
    };
  }, [event, callback]);

  // ✅ Emit with ACK (for request-response like your case)
  const emitEvent = useCallback((data = {}) => {
    return new Promise((resolve, reject) => {
      socket.emit(event, data, (response) => {
        console.log("📤 Response:", event, response);

        if (response?.status === 200) {
          resolve(response.data);
        } else {
          reject(response?.message || "Socket error");
        }
      });
    });
  }, [event]);

  return { emitEvent };
};

